<template>


    <div class="selected-tag-container">
      <div class="info">
<!--        <div class="info-label">{{ label }}</div>-->
        <div v-if="image" class="selected-image-container">
          <img  :src="image.src"  :alt="image.alt">
          <div class="image-overlay"></div>
          <svg @click="showImages=true" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.62128 3.6212C8.44955 -1.20707 16.2772 -1.20707 21.1058 3.6212C25.2972 7.8126 25.8876 14.3338 22.6833 19.1761L29.2762 25.769C29.759 26.2518 30.0004 26.8877 30.0004 27.5224C30.0004 28.6405 29.2762 29.2596 29.2762 29.2758C29.26 29.2758 28.6412 30 27.5228 30C26.8878 30 26.2522 29.7586 25.7694 29.2758L19.1765 22.6829C11.0301 28.0729 0 22.246 0 12.3633C0 9.19893 1.2073 6.03487 3.62128 3.62089V3.6212ZM11.6049 7.62111V11.6042H7.62119C6.62222 11.6042 6.62222 13.1218 7.62119 13.1218H11.6049V17.1055C11.6049 18.1045 13.1222 18.1045 13.1222 17.1055V13.1218H17.1059C18.1048 13.1218 18.1048 11.6042 17.1059 11.6042H13.1222V7.6208C13.1222 6.62183 11.6049 6.62183 11.6049 7.6208V7.62111ZM21.7601 20.399L20.3987 21.7597L26.8419 28.2029C27.7399 29.1008 29.1006 27.7398 28.2033 26.8416L21.7601 20.3987V20.399ZM4.69416 4.69377C-2.11675 11.5047 2.7243 23.209 12.3637 23.209C22.0031 23.209 26.8435 11.5044 20.0326 4.69377C15.7972 0.458391 8.92985 0.458391 4.69416 4.69377Z" fill="white"/>
          </svg>
        </div>
        <div class="tag-info">
          <div class="tag-info-name">{{selected_tag.name}}</div>
          <div class="verdieping field--name-body" v-html="is_network && selected_tag.network_body && selected_tag.network_body !== ''  ? selected_tag.network_body : selected_tag.description"/>
          <div class=" verdieping verdieping-links" v-html="selected_tag.field_links"/>
        </div>

      </div>
      <ImageModal v-if="showImages" :images="images" @close="showImages=false"/>
    </div>

</template>


<script setup lang="ts">
import {computed, ref} from 'vue';
import ImageModal from "./ImageModal.vue";


const props = defineProps({
  selected_tag: Object,
  is_network: {
    type: Boolean,
    default: false
  }
});



const showImages = ref(false);

const image = computed(() => {

  if(images.value.length > 0) {
    return images.value[0];
  }
  return null;


})

const images = computed(() => {
  let items  = [];
  let images = props.selected_tag.images.split('<img');

  images.forEach((image) => {
    if(image.match(/src="([^"]*)"/) != null && image.match(/src="([^"]*)"/)[1] != null) {
      let item = {
        src:  image.match(/src="([^"]*)"/)[1],
        alt: ''
      };
      if(image.match(/alt="([^"]*)"/) != null && image.match(/alt="([^"]*)"/)[1] != null) {
      item.alt = image.match(/alt="([^"]*)"/)[1];
      }

      items.push(item)
    }

  })
  return items;

})




</script>



